import React from "react";
import type { FC, JSX, PropsWithChildren } from "react";

import { createDisplayNameForCoreHeader } from "../../utils/createDisplayName";
import { createTestIdForCoreHeader } from "../../utils/createTestId";

import type { PropsWithTsId } from "../../../../../../types/react";

import classes from "./CoreHeaderRightAddon.styl";

const RIGHT_ADDON_TEST_ID = createTestIdForCoreHeader("right-addon");

export type CoreHeaderRightAddonProps = FC<
    PropsWithChildren<Partial<PropsWithTsId>>
>;

export const CoreHeaderRightAddon: CoreHeaderRightAddonProps = ({
    children,
    "data-tsid": tsid = RIGHT_ADDON_TEST_ID,
}): JSX.Element => {
    return (
        <div className={classes["right-addon"]} data-tsid={tsid}>
            {children}
        </div>
    );
};

CoreHeaderRightAddon.displayName = createDisplayNameForCoreHeader("RightAddon");

export default CoreHeaderRightAddon;
